export default __webpack_public_path__ + "static/media/IHKDuisburg.53f8fbb0.mp4";